import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import JobFullDetailsMainDetailsDriverBlock
  from './main-details/job-full-details-main-details-driver-block.jsx';
import { maskValue, maskEmail, maskName } from '../../maskUtils.js';

export default class JobFullDetailsMainDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      customerAllJobsPage:props.customerAllJobsPage || false
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  render() {

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            {this.state.data.fuel_included_in_job_price === 1 ?
              <strong>Fuel Included in Job Price</strong>
              :
              <strong>Fuel Not Included in Job Price</strong>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 col-sm-12">
            <div className="subsection-container">
              <h3>Pickup Required</h3>
              <div className="time-label">
                {this.state.data.pickup_preposition.toUpperCase()}&nbsp;
                {this.state.data.pickup_day}/
                {this.state.data.pickup_month}/
                {this.state.data.pickup_year} @ {
                this.state.data.pickup_time.toUpperCase()}
              </div>
              <br />
              <br />
              <br />
              <h3>Pickup Scheduled</h3>
              <div className="time-label">
                {this.state.data.scheduled_pickup_preposition?
                  this.state.data.scheduled_pickup_preposition.
                  toUpperCase():''
                }&nbsp;
                {this.state.data.scheduled_pickup_day?
                  this.state.data.scheduled_pickup_day:''
                }/
                {this.state.data.scheduled_pickup_month?
                  this.state.data.scheduled_pickup_month:''
                }/
                {this.state.data.scheduled_pickup_year?
                  this.state.data.scheduled_pickup_year:''
                } @
                {this.state.data.scheduled_pickup_time?
                  this.state.data.scheduled_pickup_time:''
                }
              </div>
            </div>

            <div className="subsection-container">
              <h3>Pickup Address</h3>
              <p><strong>House Number or Name: </strong>
                {this.state.data.pickup_address.house_number_or_name}</p>
              <p><strong>Address Line 1: </strong>
                {this.state.data.pickup_address.address_line_1}</p>
              <p><strong>Address Line 2: </strong>
                {this.state.data.pickup_address.address_line_2}</p>
              <p><strong>Address Line 3: </strong>
                {this.state.data.pickup_address.address_line_3}</p>
              <p><strong>Town/City: </strong>
                {this.state.data.pickup_address.town_city}</p>
              <p><strong>County: </strong>
                {this.state.data.pickup_address.county_area}</p>
              <p><strong>Country: </strong>
                {this.state.data.pickup_address.country}</p>
              <p><strong>Postcode: </strong> {
                (this.state.data.pickup_address.postcode != null) ?
                  this.state.data.pickup_address.postcode.toUpperCase() :
                  null
              }</p>
              <br />
              <p>
                <strong>
                  Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.pickup_address.opening_times}
              </p>

              <p>
                <strong>
                  Compound Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.pickup_address.compound_opening_times}
              </p>

              <p>
                <strong>
                  Contact Name:
                </strong>
                <br />
                {this.state.data.pickup_address.contact_name}
              </p>

              <p>
                <strong>
                  Contact Telephone Number:
                </strong>
                <br />
                {this.state.data.pickup_address.contact_telephone_number}
              </p>
            </div>

            <div className="subsection-container">
              <h3>Vehicle</h3>
              <p><strong>Colour: </strong> {
                this.state.data.vehicle.colour
              }</p>
              <p><strong>Make: </strong> {
                this.state.data.vehicle.make
              }</p>
              <p><strong>Model: </strong> {
                this.state.data.vehicle.model
              }</p>
              <p><strong>Type: </strong> {
                (this.state.data.vehicle.type === 'van') ?
                  <i className="fa fa-truck"></i> :
                  <i className="fa fa-car"></i>
              } {this.state.data.vehicle.type} </p>
              <p><strong>Registration Number: </strong> {
                ((this.state.data)&&(this.state.data.vehicle.registration_number))?this.state.data.vehicle.registration_number:''}</p>
              <p><strong>VIN Number: </strong> {
                this.state.data.vehicle.vin_number}</p>
              <p><strong>Sliding Door: </strong> {
                this.state.data.vehicle.sliding_door}</p>
              <br />
              {!this.state.customerAllJobsPage ?
              <p>
                <strong>Jet Wash Required: </strong>
                {this.state.data.jet_wash_required}
              </p>
              : ""}
              {!this.state.customerAllJobsPage ?
              <p>
                <strong>Fleet Paperwork Requirement: </strong>
                {this.state.data.fleet_paperwork_required}
              </p>
              : ""}
              {!this.state.customerAllJobsPage ?
              <p>
                <strong>Fuel included in Job Price? </strong>
                {this.state.data.fuel_included_in_job_price}
              </p>
              : ""}
              {!this.state.customerAllJobsPage ?
              <p>
                <strong>Admin Fee: </strong>
                &pound;{
                this.state.data.admin_fee_in_pence / 100
              }
              </p>
              : ""}
              {this.state.data.key_to_key_end_reg != null ? 
                <p>
                  <strong>Key To Key: </strong>
                  {this.state.data.key_to_key_end_reg}
                </p>
                : ""
              }
              {this.state.data.vehicle.fuel_type != null ? 
                <p>
                  <strong>Fuel Type: </strong>
                  {this.state.data.vehicle.fuel_type}
                </p>
                : ""
              }
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'cancelled')?
                <div>
                  <p>
                    <strong>Cancelled By : </strong>
                    {this.state.data.cancelled_by.full_name}
                  </p>
                  <p>
                    <strong>Cancelled Time : </strong>
                    {this.state.data.cancelled_at}
                  </p>
                  <p>
                    <strong>Cancellation Reason : </strong>
                    {this.state.data.cancellation_reason}
                  </p>
                </div>
                :null
              }
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'aborted')?
                <div>
                  <p>
                    <strong>Aborted By : </strong>
                    {this.state.data.aborted_by.full_name}
                  </p>
                  <p>
                    <strong>Aborted Time : </strong>
                    {this.state.data.aborted_at}
                  </p>
                  <p>
                    <strong>Abortion Reason : </strong>
                    {this.state.data.abortion_reason}
                  </p>
                </div>
                :null
              }
              {
                (this.state.data.cancelled_by_user_id != null && this.state.data.status == 'deleted')?
                <div>
                  <p>
                    <strong>Deleted By : </strong>
                    {this.state.data.deleted_by.full_name}
                  </p>
                  <p>
                    <strong>Deleted Time : </strong>
                    {this.state.data.deleted_at}
                  </p>
                  <p>
                    <strong>Deletion Reason : </strong>
                    {this.state.data.deletion_reason}
                  </p>
                </div>
                :null
              }
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="subsection-container">
              <h3>Dropoff Required</h3>
              <div className="time-label">{
                this.state.data.dropoff_preposition.
                toUpperCase()
              }&nbsp;
                {this.state.data.dropoff_day}/
                {this.state.data.dropoff_month}/
                {this.state.data.dropoff_year} @ {
                  this.state.data.dropoff_time.toUpperCase()}
              </div>
              <br />
              <br />
              <br />
              <h3>Dropoff Scheduled</h3>
              <div className="time-label">
                {this.state.data.scheduled_dropoff_preposition?
                  this.state.data.scheduled_dropoff_preposition.
                  toUpperCase() : ''
                }&nbsp;
                {this.state.data.scheduled_dropoff_day?
                  this.state.data.scheduled_dropoff_day:''
                }/
                {this.state.data.scheduled_dropoff_month?
                  this.state.data.scheduled_dropoff_month:''
                }/
                {this.state.data.scheduled_dropoff_year?
                  this.state.data.scheduled_dropoff_year:''
                } @
                {this.state.data.scheduled_dropoff_time?
                  this.state.data.scheduled_dropoff_time:''
                }
              </div>
            </div>

            <div className="subsection-container">
              <h3>Dropoff Address</h3>
              <p><strong>House Number or Name:</strong> {
                this.state.data.dropoff_address.house_number_or_name
              }</p>
              <p><strong>Address Line 1:</strong> {
                this.state.data.dropoff_address.address_line_1
              }</p>
              <p><strong>Address Line 2:</strong> {
                this.state.data.dropoff_address.address_line_2
              }</p>
              <p><strong>Address Line 3:</strong> {
                this.state.data.dropoff_address.address_line_3
              }</p>
              <p><strong>Town/City:</strong> {
                this.state.data.dropoff_address.town_city
              }</p>
              <p><strong>County:</strong> {
                this.state.data.dropoff_address.county_area
              }</p>
              <p><strong>Country:</strong> {
                this.state.data.dropoff_address.country
              }</p>
              <p><strong>Postcode:</strong> {
                (this.state.data.dropoff_address.postcode != null) ?
                  this.state.data.dropoff_address.postcode.
                  toUpperCase() : null
              }
              </p>
              <br />
              <p>
                <strong>
                  Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.dropoff_address.opening_times}
              </p>

              <p>
                <strong>
                  Compound Opening/Closing Times:
                </strong>
                <br />
                {this.state.data.dropoff_address.compound_opening_times}
              </p>

              <p>
                <strong>
                  Contact Name:
                </strong>
                <br />
                {this.state.data.dropoff_address.contact_name}
              </p>

              <p>
                <strong>
                  Contact Telephone Number:
                </strong>
                <br />
                {this.state.data.dropoff_address.contact_telephone_number}
              </p>
            </div>
            {!this.state.customerAllJobsPage ?
            <div className="subsection-container">
              <h3>Driver</h3>
              <JobFullDetailsMainDetailsDriverBlock
                data={this.state.data}
              />
            </div>
            : ""}
          </div>
          <div className="col-md-4">
            <div className="subsection-container">
              <h3>Customer</h3>
              <p><strong>Name: </strong>
              {window.hideSensitiveInfo ? (
                <a href={"/portal-admin/customers/view/"+
                this.state.data.customer.id}>{
                  this.state.data.customer.name
                }
                </a>
              ) :(
                <a href={"/portal-admin/customers/view/"+
                this.state.data.customer.id}>{
                  maskName(this.state.data.customer.name)
                }
                </a>
              )}
              </p>
              <p><strong>VAT Number: </strong> {
                this.state.data.customer.vat_number}</p>
              <p><strong>Telephone: </strong> {window.hideSensitiveInfo
                ? this.state.data.customer.telephone_1 : maskValue(this.state.data.customer.telephone_1, 2)
              }</p>
              <p><strong>Telephone: </strong> {window.hideSensitiveInfo
                ? this.state.data.customer.telephone_2 : maskValue(this.state.data.customer.telephone_2, 2)
              }</p>
            </div>
            <div className="subsection-container">
              <h3>Customer Contact</h3>
              <p><strong>Name: </strong>{window.hideSensitiveInfo
                ? this.state.data.customer.contact_name : maskName(this.state.data.customer.contact_name)
              }</p>
              <p><strong>Email: </strong> <a
                href={"mailto:"+
                this.state.data.customer.contact_email
                }>{window.hideSensitiveInfo
                  ? this.state.data.customer.contact_email
                  : maskEmail(this.state.data.customer.contact_email)}</a></p>
              <p><strong>Telephone: </strong> {window.hideSensitiveInfo
                ? this.state.data.customer.telephone_1 : maskValue(this.state.data.customer.telephone_1, 2)
              }</p>
              <p><strong>Telephone: </strong> {window.hideSensitiveInfo
                ? this.state.data.customer.telephone_2 : maskValue(this.state.data.customer.telephone_2, 2)
              }</p>
            </div>
            <div className="subsection-container">
              <h3>Customer Order Number</h3>
              <p><strong>{
                this.state.data.customer_order_number
              }</strong></p>
            </div>
            <div className="subsection-container">
              <h3>Customer Job Number</h3>
              <p><strong>{
                this.state.data.customer_job_number
              }</strong></p>
            </div>
            {!this.state.customerAllJobsPage ?
            <div className="subsection-container">
              <h3>Special Instructions</h3>
              <textarea
                className="form-control form-control-lg" rows="7"
                defaultValue={this.state.data.special_instructions}>
              </textarea>
            </div>
            : ""}
            {!this.state.customerAllJobsPage ?
            <div className="subsection-container">
              <h3>Notes</h3>
              <textarea className="form-control form-control-lg"
                        defaultValue={this.state.data.notes}>
              </textarea>
            </div>
            : ""}
            {(this.state.data.seller_preferred_dates && this.state.data.seller_preferred_dates!==null) ?
            <div className="subsection-container">
              <h3>Seller's Preferred Dates</h3>
                <label className="form-control form-control-lg text-muted">
                  {this.state.data.seller_preferred_dates
                    ? this.state.data.seller_preferred_dates
                    : "No date selected"}
                </label>
            </div>
            : ""}
          </div>
        </div>
      </div>

    )
  }
}